import { z } from 'zod'

export const reorderGroupsSchema = z.object({
  ids: z.array(z.string().guid()).min(1),
})

export type ReorderGroupsDto = z.infer<typeof reorderGroupsSchema>
